export default "/images/soir.svg?a3f1fc897bcf9080902fbe36519701ff";